<template>
  <el-card shadow="hover"
    style="margin: 0 15px">
    <div slot="header"
      class="card-header__wrap">
      <span class="card-header--title">已订购</span>
      <div class="card-header--form"></div>
    </div>
    <el-table border
      v-loading="loading"
      :data="list">
      <el-table-column label="增值服务名称">
        <template slot-scope="{row}">
          {{row.vacId | vasMap()}}
        </template>
      </el-table-column>
      <el-table-column label="生效时间">
        <template slot-scope="{row}">
          {{ (row.trialFlag === 1 ? row.trialBeginTime : row.validTime) | dateformat('YYYY-MM-DD HH:mm:ss')}}
        </template>
      </el-table-column>
      <el-table-column label="失效时间">
        <template slot-scope="{row}">
          {{ (row.trialFlag === 1 ? row.trialEndTime : row.expirationTime) | dateformat('YYYY-MM-DD HH:mm:ss')}}
        </template>
      </el-table-column>
      <el-table-column label="订购时间">
        <template slot-scope="{row}">
          {{ row.orderTime | dateformat('YYYY-MM-DD')}}
        </template>
      </el-table-column>
      <el-table-column label="付费模式">
        <template slot-scope="{row}">
          {{row.trialFlag | trialFlag()}}
        </template>
      </el-table-column>
      <el-table-column label="状态">
        <template slot-scope="{row}">
          <span v-if="row.status === 1 || row.status === 3"
            style="color:red">{{row.status | orderStatus()}}</span>
          <span v-else>{{row.status | orderStatus()}}</span>
        </template>
      </el-table-column>
      <el-table-column label="操作"
        width="240">
        <template slot-scope="{row, $index}">
          <el-switch v-if="row.status === 0 || row.status === 2"
            :value="row.stopFlag"
            active-text="开"
            inactive-text="关"
            :active-value="0"
            :inactive-value="1"
            @change="(val) => { stopFlagChange(val, row, $index)}">
          </el-switch>
          <el-button type="text"
            style="margin-left: 10px"
            @click="deletevacorder(row)"
            size="small">取消订购</el-button>
          <el-button type="text"
            v-if="row.trialFlag ===1 || (row.trialFlag === 0 && row.status === 1)"
            style="margin-left: 10px"
            @click="vacorder(1, row)"
            size="small">试用</el-button>
          <el-button type="text"
            style="margin-left: 10px"
            @click="vacorder (0, row)"
            size="small">续费</el-button>
        </template>
      </el-table-column>
    </el-table>
    <ordered-modal ref="modal"
      :type="current.type"
      :vacId="current.vacId"
      :vendorId="current.vendorId"
      :vacOrderId="current.vacOrderId"
      :startTime="current.startTime"
      :callback="callback" />
  </el-card>
</template>
<script>
import OrderedModal from './ordered-modal.vue'
export default {
  name: 'ordered-table',
  components: { OrderedModal },
  props: {
    fetch: [Function]
  },
  data () {
    return {
      loading: false,
      config: {
        pageNum: 1,
        pageSize: 10000
      },
      list: [],
      total: 0,
      current: {}
    }
  },
  methods: {
    fetchList () {
      this.loading = true
      this.$store.dispatch('vacorder/getvacorders', {
        payload: {
          ...this.config,
          vendorId: this.$route.query.vendorId
        },
        success: (res) => {
          this.loading = false
          this.total = res.data.total
          res.data.records.forEach(item => {
            if (item.trialFlag === 1) { // 试用
              item.status = Date.now() > item.trialEndTime ? 3 : 2 // 3试用过期2试用有效
            } else { // 正式使用
              item.status = Date.now() > item.expirationTime ? 1 : 0 // 1正式过期0正式有效
            }
          })
          this.list = res.data.records
        },
        fail: () => {
          this.loading = false
        }
      })
    },
    callback () {
      this.fetch && this.fetch()
    },
    deletevacorder (row) {
      this.$confirm('此操作将永久删除该增值服务, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          this.loading = true
          this.$store.dispatch('vacorder/deletevacorder', {
            payload: {
              vacOrderId: row.vacOrderId,
              vendorId: row.vendorId
            },
            success: (res) => {
              this.loading = false
              this.callback()
            },
            fail: () => {
              this.loading = false
            }
          })
        })
    },
    stopFlagChange (val, row, index) {
      console.log(val, row, index)
      if (val === 1) { // 关
        this.$prompt('请输入停用原因', '确认', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          inputPattern: /.+/,
          inputErrorMessage: '停用原因不能为空'
        }).then(({ value }) => {
          this.loading = true
          this.$store.dispatch('vacorder/stopvacorder', {
            payload: {
              vacOrderId: row.vacOrderId,
              vendorId: row.vendorId,
              stopReason: value
            },
            success: (res) => {
              this.loading = false
              row.stopFlag = val
            },
            fail: () => {
              this.loading = false
            }
          })
        })
      } else { // 开
        this.$confirm('此操作将开启该增值服务, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        })
          .then(() => {
            this.loading = true
            this.$store.dispatch('vacorder/resumevacorder', {
              payload: {
                vacOrderId: row.vacOrderId,
                vendorId: row.vendorId
              },
              success: (res) => {
                this.loading = false
                row.stopFlag = val
              },
              fail: () => {
                this.loading = false
              }
            })
          })
      }
    },
    vacorder (type, row) {
      this.current = {
        type,
        vacId: row.vacId,
        vendorId: row.vendorId,
        vacOrderId: row.vacOrderId
      }
      this.$refs.modal.toggleModal(true)
    }
  },
  mounted () {
    this.fetchList()
  }
}
</script>
<style lang="stylus"></style>
